exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MessageFlowList_flowList__3cS3R {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  min-width: 992px;\n  max-width: 1240px; }\n", ""]);

// exports
exports.locals = {
	"flowList": "MessageFlowList_flowList__3cS3R"
};